import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

// 1. Create context
export const PropertyContext = createContext();

// 2. Create provider component
export const PropertyProvider = ({ children }) => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch properties from backend
useEffect(() => {
  const fetchProperties = async () => {
    try {
      const response = await axios.get('https://investorrise-gxm0.onrender.com/api/properties');

      const mapped = response.data.map((p) => {
        const imageBaseURL = "https://investorrise-gxm0.onrender.com/uploads";
        const mappedImages = p.images?.map((img) => `${imageBaseURL}/${img}`) || [];

        return {
          ...p,
          id: p._id,
          images: mappedImages,
        };
      });

      setProperties(mapped);
    } catch (err) {
      console.error('Failed to fetch properties:', err);
    }
  };

  fetchProperties();
}, []);


  return (
    <PropertyContext.Provider value={{ properties, loading }}>
      {children}
    </PropertyContext.Provider>
  );
};
